<script setup lang="ts">
  import { useHistoryStore } from "~/stores/HistoryStore";

  const historyStore = useHistoryStore();

  interface Props {
    backTo?: string; // backToを指定するとそのパスに戻る。指定しない場合はブラウザバック。
  }
  const props = defineProps<Props>();

  const clickBack = () => {
    if (props.backTo) {
      historyStore.to(props.backTo);
    } else {
      historyStore.back();
    }
  };
</script>

<template>
  <v-btn
    class="text-content-detail-readmore px-0 cursor-pointer"
    color="transparent"
    :ripple="false"
    variant="text"
    @click="clickBack"
  >
    <span class="text-main-01 font-weight-bold d-flex">
      <v-icon icon="$mdiChevronLeft" size="large" />
      戻る
    </span>
  </v-btn>
</template>
